import cxs from 'cxs/monolithic'

cxs.prefix('gym_')

export default cxs
